import { idmsApi } from "./api";
import { API_SUBSCRIPTION_ENDPOINT } from "../../constants/endpoints";
import { ProductSubscriptionsDto } from "../interfaces/subscription";
import { CreateSubscriptionRequest, ProductSubscriptionFeatureDto, SubscriptionDTO, UpdateSubscriptionRequest } from "../../target-manager/models/subscription";

const subscriptionApi = idmsApi.injectEndpoints({
  endpoints: (builder) => ({
    getProductSubscriptions: builder.query<ProductSubscriptionsDto[], void>({
      query: () => `${API_SUBSCRIPTION_ENDPOINT}`,
      providesTags: ["ProductSubscriptions"],
    }),
    createSubscription: builder.mutation<SubscriptionDTO, CreateSubscriptionRequest>({
      query: (body) => ({
        url: `${API_SUBSCRIPTION_ENDPOINT}`,
        method: 'POST',
        body,
      }),
    }),
    updateSubscription: builder.mutation<SubscriptionDTO, UpdateSubscriptionRequest>({
      query: (body) => ({
        url: `${API_SUBSCRIPTION_ENDPOINT}`,
        method: 'PUT',
        body,
      }),
      invalidatesTags: ["ProductSubscriptions"],
    }),

    // Replace feature assignments for a subscription (batch save)
    updateSubscriptionFeatures: builder.mutation<void, { subscriptionId: string; productId: string; featureIds: string[] }>({
      query: ({ subscriptionId, productId, featureIds }) => ({
        url: `${API_SUBSCRIPTION_ENDPOINT}/${subscriptionId}/features`,
        method: 'PUT',
        body: { productId, featureIds },
      }),
      invalidatesTags: (result, _err, arg) => [
        { type: "SubscriptionFeatures", id: arg.subscriptionId },
        { type: "ProductSubscriptions", id: arg.productId },
      ],
    }),
    deleteSubscription: builder.mutation<void, string>({
      query: (subscriptionId) => ({
        url: `${API_SUBSCRIPTION_ENDPOINT}/${subscriptionId}`,
        method: 'DELETE',
      }),
      invalidatesTags: ["ProductSubscriptions"],
    }),
    getSubscriptionFeatures: builder.query<ProductSubscriptionFeatureDto[], string>({
      query: (subscriptionId) => `${API_SUBSCRIPTION_ENDPOINT}/${subscriptionId}/features`,
      providesTags: (result, _err, subscriptionId) => [{ type: "SubscriptionFeatures", id: subscriptionId }],
    }),

    getSubscriptionById: builder.query<SubscriptionDTO, { subscriptionId: string; productId: string }>({
      query: ({ subscriptionId, productId }) => `${API_SUBSCRIPTION_ENDPOINT}/${subscriptionId}/product/${productId}`,
      providesTags: (result, _err, arg) => [{ type: "ProductSubscriptions", id: arg.productId }],
    }),
  }),
});

export const {
  useGetProductSubscriptionsQuery,
  useCreateSubscriptionMutation,
  useUpdateSubscriptionMutation,
  useUpdateSubscriptionFeaturesMutation,
  useDeleteSubscriptionMutation, 
  useGetSubscriptionFeaturesQuery,
  useLazyGetSubscriptionFeaturesQuery,
  useGetSubscriptionByIdQuery,
} = subscriptionApi;
